import http from "../http-common";
import { invertMapKeysAndValues } from "./utility";

// MIT License

// Copyright (c) 2017 Kyle Corbelli

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

const authHeaderKeys = [
  "access-token",
  "token-type",
  "client",
  "expiry",
  "uid",
  "current-team-id",
];

const persistentHeaderKeys = ["current-team-id"];

export const setAuthHeaders = (headers) => {
  authHeaderKeys.forEach((key) => {
    if (headers[key]) {
      http.defaults.headers.common[key] = headers[key];
    }
  });
};

export const persistAuthHeadersInDeviceStorage = (Storage, headers) => {
  authHeaderKeys.forEach((key) => {
    if (headers[key]) {
      Storage.setItem(key, headers[key]);
    }
  });
};

export const deleteAuthHeaders = () => {
  authHeaderKeys.forEach((key) => {
    if (!persistentHeaderKeys.includes(key)) {
      delete http.defaults.headers.common[key];
    }
  });
};

export const deleteAuthHeadersFromDeviceStorage = async (Storage) => {
  authHeaderKeys.forEach((key) => {
    if (!persistentHeaderKeys.includes(key)) {
      Storage.removeItem(key);
    }
  });
};

export const getUserAttributesFromResponse = (userAttributes, response) => {
  const invertedUserAttributes = invertMapKeysAndValues(userAttributes);
  const userAttributesBackendKeys = Object.keys(invertedUserAttributes);
  const userAttributesToReturn = {};
  Object.keys(response.data.data).forEach((key) => {
    if (userAttributesBackendKeys.indexOf(key) !== -1) {
      userAttributesToReturn[invertedUserAttributes[key]] =
        response.data.data[key];
    }
  });
  return userAttributesToReturn;
};
